<template>
  <div class="CartItem grid grid-cols-12 gap-x-gr-5 mt-gr-5 leading-gr-half-7">
    <div class="col-span-2 sm:aspect-square">
      <bundle-cover v-if="promo.book?.is_bundle" :book="promo.book" hide-count class="rounded-sm" />
      <img v-else :src="`${promo.book?.cover || promo.book_cover}?w=100&q=3`" alt="" class="rounded-sm" />
    </div>
    <div class="col-span-5 sm:col-span-6 text-sm">
      <subdomain-link
        :href="route('listen.promo.view', [promo.team, promo])"
        class="link line-clamp-3"
      >
        {{ promo.book.title }}
      </subdomain-link>
      <!-- TODO: Don't show reader_signup_ends_at -->
      <!-- TODO: Do show sale_ends_at -->
      <expiry-message
        :promo="promo"
        hideTitle
        class="mt-gr-4 text-sm font-bold text-secondary-400 leading-gr-half-7"
      />
    </div>
    <div class="col-span-2 text-sm font-bold">
      <div v-if="promo.on_sale" class="line-through mb-gr-2 text-red-500 dark:text-red-400">
        {{ promoPriceFormatted }}
      </div>
      <div>{{ promo.on_sale ? promoSalePriceFormatted : promoPriceFormatted }}</div>
    </div>
    <div v-if="showRemoveBtn" class="col-span-3 sm:col-span-2 flex items-start justify-end">
      <button
        @click.prevent="onRemoveCartItem"
        class="button button-sm text-danger-500"
        title="Remove item"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
    <div v-else-if="showAddBtn" class="col-span-3 sm:col-span-2 flex items-start justify-end">
      <subdomain-link
        :href="route('cart.promo.add', [promo])"
        class="button button-sm button-primary"
        >Add</subdomain-link
      >
    </div>
    <div v-else-if="showViewBtn" class="col-span-3 sm:col-span-2 flex items-start justify-end">
      <subdomain-link
        :href="route('listen.promo.view', [promo.team, promo])"
        class="button button-sm button-default"
        >View</subdomain-link
      >
    </div>
  </div>
</template>

<script>
  import ExpiryMessage from '@/Components/ExpiryMessage';
  import BundleCover from '@/Components/BundleCover';

  export default {
    name: 'CartItem',

    props: {
      promo: Object,
      showRemoveBtn: {
        type: Boolean,
        default: false,
      },
      showAddBtn: {
        type: Boolean,
        default: false,
      },
      showViewBtn: {
        type: Boolean,
        default: false,
      },
    },

    components: {
      ExpiryMessage,
      BundleCover,
    },

    data() {
      return {
        removeFromCartForm: this.$inertia.form({
          promo_id: this.promo.id,
        }),
      };
    },

    computed: {
      promoPriceFormatted() {
        let val = this.promo.digital_listing_price;
        return val
          ? val.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })
          : '';
      },

      promoSalePriceFormatted() {
        let val = this.promo.sale_price;
        return val
          ? val.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })
          : '';
      },
    },

    methods: {
      onRemoveCartItem() {
        this.removeFromCartForm.post(route('cart.promo.remove', { promo_id: this.promo.id }), {
          onSuccess: () => {},
          onError: (error) => {
            console.log('%c error -->', 'color:#F80', error);
          },
        });
      },
    },
  };
</script>

<!-- <style lang="scss" src="./CartItem.scss" scoped></style> -->
